import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_psb";
import {connect} from "react-redux";

import {logoutUserAction} from "../../../modules/auth/Actions"
import {authTokenSelector} from "../../../modules/auth/Selectors"


class Logout extends Component {
  componentDidMount() {
    this.props.logoutUser();
  }

  render() {
    const { authToken } = this.props;
    return authToken ? <LayoutSplashScreen /> : <Redirect to="/auth" />;
  }
}

const mapStateToProps = (state) => ({
  authToken : authTokenSelector(state)
}) 

export default connect(mapStateToProps, {
  logoutUser : logoutUserAction
})(Logout)
